import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { IconBox } from '../../IconBox/index.js';

var InputIcon = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? "md" : _b, props = __rest(_a, ["children", "size"]);
    return (jsx(IconBox, __assign({ size: size, position: "center", themeKey: "buttonIcons", sx: { color: "black.60" } }, props, { children: children })));
};
InputIcon.displayName = "InputIcon";

export { InputIcon };
//# sourceMappingURL=InputIcon.js.map
